/**
 * Loading screen wrappers built on MiDHouseLoader.
 *
 * <LoadingScreen />    — full-page centered loader (replaces min-h-screen spinners)
 * <LoadingBlock />     — inline loader for a section/card (replaces w-8 spinners)
 *
 * Both are indeterminate (auto-cycling). For determinate progress use
 * MiDHouseLoader directly with a `progress` prop.
 */
import React from "react";
import { MiDHouseLoaderAuto } from "./MiDHouseLoader";

export function LoadingScreen({
  label = "A carregar…",
  size = 220,
  minHeight = "100vh",
  className = "",
}) {
  return (
    <div
      className={`flex items-center justify-center ${className}`}
      style={{ minHeight, background: "var(--brand-paper, #FAFAF7)" }}
      data-testid="mid-loading-screen"
    >
      <MiDHouseLoaderAuto size={size} label={label} />
    </div>
  );
}

export function LoadingBlock({
  label = "A carregar…",
  size = 140,
  className = "",
  minHeight = 220,
}) {
  return (
    <div
      className={`flex items-center justify-center py-8 ${className}`}
      style={{ minHeight }}
      data-testid="mid-loading-block"
    >
      <MiDHouseLoaderAuto size={size} label={label} scene={false} />
    </div>
  );
}

export default LoadingScreen;
